
import { IconPicker as ShadcnIconPicker, Icon, type IconName } from '@/components/ui/icon-picker';
import { Button } from '@/components/ui/button';
import { Folder } from 'lucide-react';

interface IconPickerProps {
  value?: string | null;
  onChange: (iconName: string | null) => void;
  disabled?: boolean;
}

export function IconPicker({ value, onChange, disabled }: IconPickerProps) {
  const iconValue = value as IconName | undefined;
  
  const handleValueChange = (newIcon: IconName | undefined) => {
    // If clicking the same icon, clear it (toggle behavior)
    if (newIcon === iconValue) {
      onChange(null);
    } else {
      onChange(newIcon || null);
    }
  };

  return (
    <ShadcnIconPicker
      value={iconValue}
      onValueChange={handleValueChange}
      disabled={disabled}
      searchable={true}
      categorized={true}
      triggerPlaceholder="Select icon"
      searchPlaceholder="Search icons..."
    >
      <Button
        type="button"
        variant="outline"
        className="w-full justify-start"
        disabled={disabled}
      >
        {iconValue ? (
          <>
            <Icon name={iconValue} className="h-6 w-6" />
            {/* <span className="flex-1 text-left">{iconValue}</span> */}
          </>
        ) : (
          <>
            <Folder className="mr-2 h-4 w-4 opacity-50" />
            <span className="flex-1 text-left text-muted-foreground">Select icon</span>
          </>
        )}
      </Button>
    </ShadcnIconPicker>
  );
}
